<script setup>
import { useWindowScroll } from '@vueuse/core'
import { preferredScrollBehavior } from '@/utils/scrollBehavior'

const { y } = useWindowScroll()

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: preferredScrollBehavior(),
  })
}
</script>

<template>
  <Transition
    name="app-transition-zoom-fade"
    style="transform-origin: center"
  >
    <button
      v-show="y > 200"
      type="button"
      class="scroll-to-top d-print-none"
      aria-label="Scroll to top"
      @click="scrollToTop"
    >
      <VIcon
        size="20"
        icon="tabler-arrow-up"
      />
    </button>
  </Transition>
</template>

<style lang="scss">
/* A quiet tile in the app navigation's style rather than a floating accent button. */
.scroll-to-top {
  position: fixed;

  // To keep button on top of v-layout. E.g. Email app
  z-index: 999;
  display: grid;
  border: 1px solid rgba(var(--v-theme-on-surface), 0.1);
  border-radius: 12px;
  background: rgb(var(--v-theme-background));
  block-size: 40px;
  color: rgba(var(--v-theme-on-surface), 0.62);
  cursor: pointer;
  inline-size: 40px;
  inset-block-end: 20px;
  inset-inline-end: 20px;
  place-items: center;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;
}

.scroll-to-top:hover {
  background: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-on-surface));
}

.scroll-to-top:focus-visible {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}
</style>
